// extracted by mini-css-extract-plugin
module.exports = {"heroContent":"hero_heroContent__C8jNF","playerWrapper":"hero_playerWrapper__KJbKg"};